module.exports = __webpack_public_path__ + "imgs/strain.4b7161d0d05cd6808253ae486c377524.svg";